let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jynfz")).then(() => parcelRequire('c3H0z'));